import { render, staticRenderFns } from "./brand-campaign-toll-free-verification.vue?vue&type=template&id=30e0c61c&scoped=true&"
import script from "./brand-campaign-toll-free-verification.vue?vue&type=script&lang=js&"
export * from "./brand-campaign-toll-free-verification.vue?vue&type=script&lang=js&"
import style0 from "./brand-campaign-toll-free-verification.vue?vue&type=style&index=0&id=30e0c61c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e0c61c",
  null
  
)

export default component.exports